import {
  COMMISSIONS_GET_ALL_PERIODS_BEGIN,
  COMMISSIONS_GET_ALL_PERIODS_SUCCESS,
  COMMISSIONS_GET_ALL_PERIODS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_ALL_PERIODS_BEGIN:
      return {
        ...state,
        commissionList: {
          ...state.commissionList
        }
      }
    case COMMISSIONS_GET_ALL_PERIODS_SUCCESS:
      return {
        ...state,
        commissionList: {
          ...state.commissionList,
          periodsOptions: action.data
        }
      }

    case COMMISSIONS_GET_ALL_PERIODS_FAILURE:
      return {
        ...state,
        commissionList: {
          ...state.commissionList
        }
      }
    default:
      return state
  }
}
